import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';

export const AccountBasicInfoComponent = ({ handleInnerFormChange, selectedAccounts }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="FirstName"
                    name="FirstName"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'UserInfo.FirstName',
                            selectedAccounts?.UserInfo
                        )
                    }}
                    type="text"
                    value={selectedAccounts?.UserInfo?.FirstName}
                />

                <InputContainer
                    label="LastName"
                    name="LastName"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'UserInfo.LastName',
                            selectedAccounts?.UserInfo
                        )
                    }}
                    type="text"
                    value={selectedAccounts?.UserInfo?.LastName}
                />

                <InputContainer
                    label="Email"
                    name="Email"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'LoginInfo.Email',
                            selectedAccounts?.LoginInfo
                        )
                    }}
                    type="text"
                    value={selectedAccounts?.LoginInfo?.Email}
                />
                <InputContainer
                    label="PhoneNumber"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'LoginInfo.PhoneNumber',
                            selectedAccounts?.LoginInfo
                        )
                    }}
                    type="phonenumber"
                    value={selectedAccounts?.LoginInfo?.PhoneNumber}
                />
                <InputContainer
                    icon
                    label="Password"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'LoginInfo.Password',
                            selectedAccounts?.LoginInfo
                        )
                    }}
                    type="password"
                    value={selectedAccounts?.LoginInfo?.Password}
                />
                <InputContainer
                    label="Confirm Password"
                    icon
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'LoginInfo.ConfirmPassword',
                            selectedAccounts?.LoginInfo
                        )
                    }}
                    type="password"
                    value={selectedAccounts?.LoginInfo?.ConfirmPassword}
                />
            </div>
        }
        expandedPanel="PersonalInfo"
        headerTitle="Personal Info"
    />
        <AddressContainer
            onInnerFormChange={handleInnerFormChange}
            selectedAddress={selectedAccounts}
        />
    </>

)
export default AccountBasicInfoComponent;
